var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn1",attrs:{"href":_vm.href}},[_c('span',{staticClass:"btnText"},[_vm._v(_vm._s(_vm.btnText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }